import { apiGet } from '../../../api/default';
import { httpFailed, httpError } from '../../../js/http'
import { safeCall } from '../../../js/promise'
import portfolioApi from '../../../api/portfolioApi'

export const doAuthentication = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        portfolioApi.authenticatePnl()
            .then((res) => {
                commit('SET_PNL_AUTH', res?.authenticated);
                resolve(res);
            }).catch((e) => {
                reject(e);
            });
        });
}

export const getModels = ({ commit, dispatch, state }, { acctId, onSuccess, onError }) => {
     portfolioApi.getModels(acctId)
        .then((res) => {
            safeCall('get-models', onSuccess, res);
        })
        .catch((result) => {
            safeCall('get-models', onError, result);
            httpFailed("get models", commit, result);
        });
}

export const getIbkramModelInfo = ({ commit, dispatch, state }, { model, onSuccess, onError }) => {
    portfolioApi.getIbkramModelInfo(model)
        .then((result) => {
            safeCall('get-model-info', onSuccess, result);
        })
        .catch((result) => {
            safeCall('get-model-info', onError, result);
            httpFailed('get model info', commit, result);
        })
}

export const getNlv = ({ commit, dispatch, state }, { acctId, model, onSuccess, onError }) => {
    portfolioApi.getNlv(acctId, model)
        .then(res => safeCall(name, onSuccess, res))
        .catch(res => safeCall(name, onError, res));
}

export const getPositions = ({ commit, dispatch, state }, {
        acctId,
        model = '',
        pageId,
        period = '7D',
        sortBy = 'name',
        sortDir = 'a',
        el,
        clear = false,
        final = false,
        onSuccess,
        onError = null
    }) => {

    if (!acctId) {
        safeCall('positions', onError, 'Invalid account id');
        return;
    }

    apiGet('/portfolio/' + acctId  + '/positions/' + pageId + '?' + new URLSearchParams({
        model,
        sort: sortBy,
        direction: sortDir,
        period,
        final
    }))
        .then((res) => {
            safeCall(name, onSuccess, res);
        })
        .catch((result) => {
            safeCall('get-positions', onError, result);
            httpFailed("get postitions ", commit, result);
        });
}

export const getPositions2 = ({ commit, dispatch, state }, {
        acctId,
        model,
        el,
        onSuccess,
        sort,
        direction,
        onError = null
    }) => {

    if (!acctId) {
        safeCall('positions2', onError, 'Invalid account id');
        return;
    }

    portfolioApi.getPositions2(acctId, model, sort, direction)
        .then((res) => {
            safeCall(name, onSuccess, res);
        })
        .catch((result) => {
            safeCall('get-positions2', onError, result);
            httpFailed("get postitions2 ", commit, result);
        });
}

// is used only by wide quote details for now
export const getPositions3 = ({ commit, dispatch, state }, {
        acctId,
        model,
        el,
        onSuccess,
        onError = null
    }) => {

    if (!acctId) {
        safeCall('positions3', onError, 'Invalid account id');
        return;
    }

    portfolioApi.getPositions3(acctId, model)
        .then((res) => {
            commit('SET_PTF_POSITIONS', { acctId, model, data: res });
            safeCall(name, onSuccess, res);
        })
        .catch((result) => {
            safeCall('get-positions3', onError, result);
            httpFailed("get postitions3 ", commit, result);
        });
}

export const getPnlPositions = ({ commit, dispatch, state }, {
        acctId,
        model,
        el,
        onSuccess,
        onError = null
    }) => {

    if (!acctId) {
        safeCall('getPnlPositions', onError, 'Invalid account id');
        return;
    }

    portfolioApi.getPnlPositions(acctId, model)
        .then((res) => {
            commit('SET_PNL_POSITIONS', { acctId, model, data: res });
            safeCall(name, onSuccess, res);
            dispatch('subscribePositions', { acctId, model });
        })
        .catch((result) => {
            safeCall('get-pnl-positions', onError, result);
            httpFailed("get pnl positions", commit, result);
        });
}

export const getPositionMetals = ({ commit, dispatch, state }, { acctId, model, onSuccess, onError }) => {
    portfolioApi.getPositionMetals(acctId, model)
        .then(res => safeCall(name, onSuccess, res))
        .catch(res => safeCall(name, onError, res));
}

export const getComboPositions = ({ commit, dispatch, state }, { acctId, force }) => {
    return new Promise((resolve, reject) => {
        if (!acctId) {
            reject(`Account missing`)
        } else if (!force && state.comboPositions[acctId]) {
            // serve data which was already fetched
            resolve(state.comboPositions[acctId]);
        } else {
            // fetch combo positions
            portfolioApi.getComboPositions(acctId, force)
                .then(res => {
                    commit('SET_COMBO_POSITIONS', { acctId, data: res });
                    resolve(res);
                })
                .catch(e => {
                    reject(httpError(e));
                });
        }
    });
}


export const getAccountSummary = ({ commit, dispatch, state }, { acctId, onSuccess, onError }) => {
    if (!acctId) {
        safeCall('account-summary', onError, 'Invalid account id');
        return;
    }
    return portfolioApi.getAccountSummary(acctId)
        .then((res) => {
            if (Array.isArray(res)) {
                const obj = {};
                for (let i = 0; i < res.length; i++) {
                    const key = res[i]['key'];
                    if (key) {
                        obj[key.toLocaleLowerCase()] = {
                            amount: res[i]['monetaryValue'],
                            ...res[i]
                        };
                    }
                }
                if (Object.keys(obj).length > 0) {
                    commit('SET_ACCOUNT_SUMMARY', { acctId: acctId, data: obj });
                }
            } else {
                commit('SET_ACCOUNT_SUMMARY', { acctId: acctId, data: res });
            }
            safeCall('account-summary', onSuccess, res);
        })
        .catch((result) => {
            safeCall('get-account-summary', onError, result);
            httpFailed("get account summary ", commit, result);
        });
}


export const getAccountLedger = ({ commit, dispatch, state }, { acctId, model, onSuccess, onError }) => {
    if (!acctId) {
        safeCall('account-ledger', onError, 'Invalid account id');
        return;
    }
    return portfolioApi.getAccountLedger(acctId)
        .then((res) => {
            if (Array.isArray(res)) {
                const obj = {};
                for (let i = 0; i < res.length; i++) {
                    const currency = res[i]['secondKey'];
                    if (currency) {
                        const toLowerObj = {};
                        for (const key in res[i]) {
                            toLowerObj[key.toLocaleLowerCase()] = res[i][key];
                        }
                        obj[currency] = toLowerObj;
                    }
                }
                if (Object.keys(obj).length > 0) {
                    commit('SET_ACCOUNT_LEDGER', { acctId: acctId, data: obj });
                }
            } else {
                commit('SET_ACCOUNT_LEDGER', { acctId: acctId, data: res });
            }
            if (onSuccess) onSuccess();
            safeCall('account-ledger', onSuccess, res);
        })
        .catch((result) => {
            safeCall('get-account-ledger', onError, result);
            httpFailed("get account ledger", commit, result);
        });
}

export const getPortfolioAllocation = ({ commit, dispatch, state }, { acctIds, model, onSuccess, onError }) =>
    portfolioApi.postPortfolioAllocation(acctIds, model)
        .then((res) => {
            commit('SET_PORTFOLIO_ALLOCATION', res);
            safeCall('get portfolio alloc', onSuccess, res);
        })
        .catch((result) => {
            safeCall('get allocation httpFailed', onError, result);
            httpFailed("get portfolio allocation ", commit, result);
        });

export const getIbkrAmInfo = ({ commit, dispatch, state }, { modelcodes }) =>
    portfolioApi.getIbkrAmInfo(modelcodes)
        .then((res) => commit('SET_IBKRAM_INFO', res))
        .catch((result) => httpFailed('get ibkr am info', commit, result));

/**
 * accts contain list of accounts provided by AMPicker which need to be validated.
 * If validateOnly option is true, the accounts will only be validated but will not be available for
 * user to select as portfolio account in the UI
 */
export const validateAccounts = ({ commit, dispatch, state }, { accts, validateOnly, onSuccess, onError }) =>
    portfolioApi.validateAccounts(accts)
        .then(res => {
            if (res && res.length > 0) {
                safeCall('validate-accounts', onSuccess, res);
            } else {
                safeCall('validate-accounts', onError, []);
            }
        }).catch(res => httpFailed('validate accounts', commit, res));


export const invalidatePositions = ({ commit, dispatch, state }, { acctId, onSuccess }) =>
    portfolioApi.invalidatePositions(acctId)
        .then((res) => {
            if (onSuccess) onSuccess();
        })
        .catch((result) => {
            httpFailed("invalidate positions", commit, result);
        });

export const invalidateAllPositions = ({ commit, dispatch, state }, { onSuccess }) =>
    portfolioApi.invalidateAllPositions()
        .then((res) => {
            if (onSuccess) onSuccess();
        })
        .catch((result) => {
            httpFailed("invalidate all positions", commit, result);
        });

export const getAccountMeta = ({ commit, dispatch, state }, { acctId, onSuccess, onError }) =>
    portfolioApi.getAccountMeta(acctId).then((res) => {
        if (res.error) {
            safeCall('getAccountMeta: get account meta', onError, {});
        } else {
            commit('SET_ACCOUNT_META', res);
            safeCall('getAccountMeta: get account meta', onSuccess, res);
        }
    })
    .catch((result) => {
        safeCall('getAccountMeta: get account meta', onError, {});
        httpFailed('getAccountMeta: get account meta', commit, result);
    });

export const getModelsLedger = ({ commit, dispatch, state }, { acctId, tryAgain }) =>
    portfolioApi.getModels(acctId)
        .then(res => {
            //-- to get the modelcodes split name by dot and get the second part
            const usersModelCodes = res.map(m => m.name.split('.').pop());
            dispatch('getIbkrAmInfo', { modelcodes: usersModelCodes });
            res.forEach(model => {
                portfolioApi.getAccountLedger(acctId, model.name)
                    .then(res => {
                        commit('SET_MODELS_LEDGER', {
                            acctId: acctId,
                            modelName: model.name,
                            modelDescription: model.description,
                            data: res.BASE
                        });
                    })
            });
        })
        .catch(e => {
            if (tryAgain > 0) {
                tryAgain --;
                setTimeout(() => dispatch('getModelsLedger', { acctId, tryAgain }), 3000);
            }
        });

export const fetchAllPositionsConids = ({ commit, dispatch, state }, { acctId }) => {
    if(state.portfolioPositions[acctId] && state.portfolioPositions[acctId].length > 0) {
        return state.portfolioPositions[acctId];
    } else {
        portfolioApi.getAllPositions(acctId)
            .then(res => {
                commit('PTF_POSITIONS_SIMPLE', {
                    acctId: acctId,
                    list: res
                });
            });
    }
}

export const getPortfolioAccounts = ({ commit }, {} ) => {
    return new Promise((resolve, reject) => {
        portfolioApi.getPortfolioAccounts()
            .then(res => {
                commit('SET_PORTFOLIO_ACCOUNTS', res);
                resolve(res);
            })
            .catch(err => {
                httpFailed('Failed to get portfolio accounts', commit, err);
                reject(err);
            });
    });
}

/**
 * Subscribe positions(including combo and pnl) data for the given account id and model
 */
const subscribedKeys = new Set();
const subscribedHanlders = new Map();
export const subscribePositions = ({ commit, dispatch, rootGetters }, { acctId, model, onSuccess, onError  }) => {
    if (!acctId) {
        return;
    }
    const realtime = rootGetters.realtime;
    if (realtime === undefined) {
        console.error('Transport mode unknown. Couldnt subscribe to positions', acctId);
        return;
    }

    const key = acctId + model;
    if (subscribedKeys.has(key)) {
        const handlers = subscribedHanlders.get(key);
        if (onSuccess) {
            handlers.push(onSuccess);
        }
        safeCall('subscribePositions', onSuccess, {});
        return;
    } else {
        subscribedKeys.add(key);
        if (onSuccess) {
            subscribedHanlders.set(key, [onSuccess]);
        } else {
            subscribedHanlders.set(key, []);
        }
    }
    const onUpdates = msg => {
        const data = msg.args;
        commit('SET_PNL_POSITIONS', { acctId, model, data });
        if (Object.keys(data.positions).length > 0) {
            const handlers = subscribedHanlders.get(key);
            handlers.forEach(s => {
                safeCall('subscribePositions', s, data);
            });
        }
    };
    if (realtime) { // send request via websockets
        portfolioApi.subscribePositions(
            {
                'acctId': acctId,
                'model': model,
            }, {
                onUpdates
            }
        );
    } else { // send request via REST
        portfolioApi.getPnlPositions(acctId, model).then(onUpdates);
    }
}

export const unsubscribePositions = ({ commit, dispatch, rootGetters }, { acctId, model, onSuccess, onError  }) => {
    if (!acctId) {
        return;
    }
    const realtime = rootGetters.realtime;
    if (realtime === undefined) {
        console.error('Transport mode unknown. Couldnt unsubscribe to positions', acctId);
        return;
    }
    const key = acctId + model;
    subscribedKeys.delete(key);
    subscribedHanlders.delete(key);

    if (realtime) { // send request via websockets
        portfolioApi.unsubscribePositions(acctId, model);
    } else { // send request via REST
        portfolioApi.unsubscribePositions(acctId, model);
    }
}
